<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getPostingSupplyForProductions" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="pickingSupplyForProductions"
							optionsLabel="workOrderSupplyWorkOrderSupplyNumber" optionsKey="id" label-cols-sm="4"
							label-cols-lg="3" label="Picking Supply For Production" id="filter-" size="sm"
							:model.sync="filter.pickingSupplyForProductionId" @input="getPickingSupplyForProductions"
							@focus="getPickingSupplyForProductions" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Line" id="filter-" size="sm"
							:model.sync="filter.lineId" @input="getLines" @focus="getLines" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker-range id="fieldset-work-order-supply-date" label-cols-sm="4"
							label-cols-lg="3" label="Work Order Supply Date" size="sm"
							:modelFrom.sync="filter.workOrderSupplyDateFrom"
							:modelTo.sync="filter.workOrderSupplyDateTo"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							reset-button />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm"
							:model.sync="filter.documentStatusId" @input="getDocumentStatuss"
							@focus="getDocumentStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear
							Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1"
							@click="getPostingSupplyForProductions"><span style="font-size: 0.75rem"
								class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Posting Supply For Production</span>
				</b-col>
				<!-- <b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)"
								href="files/postingsupplyforproduction/PostingSupplyForProduction.xlsx"><b-icon-wallet
									class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)"
								@click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload
								Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)"
								@click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To
								Pdf</b-dropdown-item>
						</b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
							opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square
									class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
								opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
								<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
									<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>

						</span>
					</Portal>
				</b-col> -->
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"
						v-if="!isDisabledFeatures"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton && !isDisabledFeatures" :show="isDeleteBusy" rounded
						opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash
									class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' |
							countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-postingsupplyforproduction"
					:class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light"
					:bordered="true" :no-local-sorting="true" :items="postingSupplyForProductions" :fields="fields"
					:busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty
					:tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="postingSupplyForProductions.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Picking Supply For Production" class="table-filter">
							<v-select append-to-body label="workOrderSupplyWorkOrderSupplyNumber"
								:options="pickingSupplyForProductions" :value="filter.pickingSupplyForProductionId"
								:reduce="item => item.id" v-model="filter.pickingSupplyForProductionId"
								:filterable="true" @input="getPostingSupplyForProductionsWithoutLoading"
								@search="getPickingSupplyForProductions"></v-select>
						</b-th>
						<b-th stacked-heading="Line" class="table-filter">
							<v-select append-to-body label="code" :options="lines" :value="filter.lineId"
								:reduce="item => item.id" v-model="filter.lineId" :filterable="true"
								@input="getPostingSupplyForProductionsWithoutLoading" @search="getLines"></v-select>
						</b-th>
						<b-th stacked-heading="Work Order Supply Date" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder=""
								id="input-work-order-supply-date-from-table" reset-button
								@input="getPostingSupplyForProductionsWithoutLoading"
								v-model="filter.workOrderSupplyDateFrom" size="sm"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder=""
								id="input-work-order-supply-date-to-table" reset-button
								@input="getPostingSupplyForProductionsWithoutLoading"
								v-model="filter.workOrderSupplyDateTo" size="sm"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB"></b-form-datepicker>
						</b-th>
						<b-th stacked-heading="Document Status" class="table-filter">
							<v-select append-to-body label="name" :options="documentStatuss"
								:value="filter.documentStatusId" :reduce="item => item.id"
								v-model="filter.documentStatusId" :filterable="true"
								@input="getPostingSupplyForProductionsWithoutLoading"
								@search="getDocumentStatuss"></v-select>
						</b-th>

						<b-th stacked-heading="Select All">
							<b-form-checkbox v-if="false" id="input-select-all" class="float-right d-block d-md-none"
								v-model="selectAll"></b-form-checkbox>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(pickingsupplyforproduction)="row">
						<a @click="() => ($router.push({ name: 'postingsupplyforproductionscan', params: { id: row.item.id } }))"
							class="a-link-detail">
							{{ row.item.pickingSupplyForProduction != null &&
								row.item.pickingSupplyForProduction.workOrderSupply != null &&
								row.item.pickingSupplyForProduction.workOrderSupply.workOrderSupplyNumber != null ?
								(typeof row.item.pickingSupplyForProduction.workOrderSupply.workOrderSupplyNumber ==
									'string') ?
									row.item.pickingSupplyForProduction.workOrderSupply.workOrderSupplyNumber.slice(0, 30) +
									(row.item.pickingSupplyForProduction.workOrderSupply.workOrderSupplyNumber.length > 30 ?
										"..." :
										"") :
									row.item.pickingSupplyForProduction.workOrderSupply.workOrderSupplyNumber : "" }}
						</a>
					</template>

					<template v-slot:cell(workOrderSupply)="row">
						{{ row.item.workOrderSupply != null ? row.item.workOrderSupply.workOrderSupplyDate : "" }}
					</template>
					<template v-slot:cell(workOrderProcess)="row">
						{{ row.item.workOrderProcess != null ? row.item.workOrderProcess.workOrderProcessNumber : "" }}
					</template>
					<template v-slot:cell(line)="row">
						{{ row.item.line != null ? row.item.line.code : "" }}
					</template>
					<template v-slot:cell(workOrderSupplyDate)="row">
						{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY") }}
					</template>
					<template v-slot:cell(documentstatus)="row">
						{{ getDocumentStatusName(row.item.documentStatusId) }}
					</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="false">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)"
								@change="toggleSelect(Number(row.item.id))"
								:checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-combobox optionsLabel="workOrderProcessNumber" label-cols-sm="12"
								:model="row.item.workOrderProcessId" label="Work Order Process Id"
								:selected="row.item.workOrderProcess != null ? row.item.workOrderProcess.workOrderProcessNumber : ''"
								:isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.lineId"
								label="Line" :selected="row.item.line != null ? row.item.line.code : ''"
								:isEditable="false" :isUpdatable="true" />
							<app-input-datepicker id="fieldset-work-order-supply-date" label-cols-lg="12"
								label="Work Order Supply Date" size="sm" :model.sync="row.item.workOrderSupplyDate"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB" :isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="name" label-cols-sm="12"
								:model="row.item.documentStatusId" label="Document Status"
								:selected="row.item.documentStatusName" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
					<template v-slot:cell(Status)="row">
						<!-- {{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }} -->
						<div :id="getStatus(row.item.documentStatusId)">
						</div>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(postingSupplyForProductionsPaging != null ? postingSupplyForProductionsPaging.dataCount : 0)"
									:per-page="(postingSupplyForProductionsPaging != null ? postingSupplyForProductionsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId"
			@resetModalMethod="resetModal" label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-postingsupplyforproduction.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}

::v-deep #table-list-postingsupplyforproduction.b-table>thead>tr>th {
	background: #e28b29;
}

::v-deep #table-list-postingsupplyforproduction.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}

#box-green {
	width: 30px;
	height: 30px;
	background-color: green;
}

#box-yellow {
	width: 30px;
	height: 30px;
	background-color: yellow;
}

#box-red {
	width: 30px;
	height: 30px;
	background-color: red;
}
</style>
<script>
import PostingSupplyForProduction from '@/models/PostingSupplyForProduction/PostingSupplyForProduction';
import PostingSupplyForProductionList from '@/models/PostingSupplyForProduction/PostingSupplyForProductionList';
import PostingSupplyForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyForProductionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';
import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import LineFilter from '@/filters/Line/LineFilter';
import Line from '@/models/Line/Line';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import AreaFilter from '@/filters/Area/AreaFilter';
import Area from '@/models/Area/Area';
import RackFilter from '@/filters/Rack/RackFilter';
import Rack from '@/models/Rack/Rack';
import PostingSupplyDetailForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyDetailForProductionFilter';
import PostingSupplyDetailForProduction from '@/models/PostingSupplyForProduction/PostingSupplyDetailForProduction';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components: {
		PostingSupplyForProduction,
		PostingSupplyForProductionList,
		PostingSupplyForProductionFilter,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "pickingSupplyForProduction": {}, "class": "th-picking-supply-for-production first-child", "label": "Picking Supply For Production", key: 'pickingSupplyForProduction', sortable: true },
				/*{ "workOrderSupply": {}, "class": "th-work-order-supply", "label": "Work Order Supply Id", key: 'workOrderSupply', sortable: true },
				{ "workOrderProcess": {}, "class": "th-work-order-process last-child", "label": "Work Order Process Id", key: 'workOrderProcess', sortable: true },*/
				{ "line": {}, "class": "th-line", "label": "Line", key: 'line', sortable: true },
				{ "workOrderSupplyDate": {}, "class": "th-work-order-supply-date d-stack-none", "label": "Work Order Supply Date", key: 'workOrderSupplyDate', sortable: true },
				{ "documentstatus": {}, "class": "th-document-status d-stack-none", "label": "Status", key: 'documentStatus', sortable: true },
				{ "status": {}, "class": "th-document-status", "label": "Status", key: 'Status', sortable: false },

				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			postingSupplyForProductions: [],
			postingSupplyForProductionsPaging: {},
			pickingSupplyForProductions: [],
			workOrderSupplys: [],
			workOrderProcesss: [],
			lines: [],
			documentStatuss: [],
			postingSupplyDetailForProductions: [],
			postingSupplyCases: [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isDisabledFeatures: true,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
		}
	}, methods: {
		getDocumentStatusName(status) {
			switch (status) {
				case 'OPEN':
					return 'OPEN';
				case 'IN_PROGRESS':
					return 'Progress Posting';
				case 'CLOSED':
					return 'Finish Posting';
				default:
					return '';
			}
		},
		getStatus(status) {
			switch (status) {
				case 'OPEN':
					return 'box-red';
				case 'IN_PROGRESS':
					return 'box-yellow';
				case 'CLOSED':
					return 'box-green';
				default:
					return '';
			}
		},
		getPostingSupplyForProductions: async function () {
			this.isDataLoading = true;
			//this.sortingBy["createddate"] = 1;
			this.sortingBy = new Array();
			if (this.sortBy) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			} else {
				this.sortingBy["documentstatus"] = 1;
				this.sortingBy["createdDate"] = 0;
			}

			this.filter["isDataFromLast7Days"] = false;

			if (!this.filter.pickingSupplyForProductionId && !this.filter.lineId && !this.filter.documentStatusId && !this.filter.workOrderSupplyDateFrom && !this.filter.workOrderSupplyDateTo) {
				this.filter["isDataFromLast7Days"] = true;
			}
			PostingSupplyForProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.postingSupplyForProductions = result.data
						this.postingSupplyForProductionsPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getPostingSupplyForProductionsWithoutLoading: async function () {
			this.sortingBy = new Array();
			if (this.sortBy) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			} else {
				this.sortingBy["documentstatus"] = 1;
				this.sortingBy["createdDate"] = 0;
			}

			this.filter["isDataFromLast7Days"] = false;

			if (!this.filter.pickingSupplyForProductionId && !this.filter.lineId && !this.filter.documentStatusId && !this.filter.workOrderSupplyDateFrom && !this.filter.workOrderSupplyDateTo) {
				this.filter["isDataFromLast7Days"] = true;
			}
			PostingSupplyForProduction.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.postingSupplyForProductions = result.data
						this.postingSupplyForProductionsPaging = result
					}
				})
				.catch(error => { });
		},
		getPickingSupplyForProductions: async function (input) {
			let filter = new PickingSupplyForProductionFilter();
			if (input != undefined) {
				filter.workOrderSupply = input;
			}
			PickingSupplyForProduction.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.pickingSupplyForProductions = result.data
					}
				})
				.catch(error => { });
		},
		getWorkOrderSupplys: async function (input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			WorkOrderSupply.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderSupplys = result.data
					}
				})
				.catch(error => { });
		},
		getWorkOrderProcesss: async function (input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			WorkOrderProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderProcesss = result.data
					}
				})
				.catch(error => { });
		},
		getLines: async function (input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.lines = result.data
					}
				})
				.catch(error => { });
		},
		getDocumentStatuss: async function (input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.documentStatuss = result.data
					}
				})
				.catch(error => { });
		},

		resetFilter() {
			this.filter = new PostingSupplyForProductionFilter();
			this.getPostingSupplyForProductions();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPostingSupplyForProductions();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PostingSupplyForProduction.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PostingSupplyForProduction.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PostingSupplyForProduction.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},
		createData() {
			this.isCreateBusy = true;
			PostingSupplyForProduction.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'postingsupplyforproductionedit';
						if (this.isScannerMode) {
							createRoute = 'postingsupplyforproductionscan';
						}

						this.$router.push({ name: createRoute, params: { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			PostingSupplyForProduction.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'postingsupplyforproductionedit', params: { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			PostingSupplyForProduction.deleteData(this, id).then(result => {
				if (result) {
					this.getPostingSupplyForProductions();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PostingSupplyForProduction.deleteMultipleData(this).then(result => {
					this.getPostingSupplyForProductions();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePostingSupplyForProductionParent = document.getElementById('table-list-postingsupplyforproduction').parentNode;
			tablePostingSupplyForProductionParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePostingSupplyForProductionParent.scrollWidth - tablePostingSupplyForProductionParent.offsetWidth) == Math.ceil(tablePostingSupplyForProductionParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePostingSupplyForProductionParent = document.getElementById('table-list-postingsupplyforproduction').parentNode;
			tablePostingSupplyForProductionParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePostingSupplyForProductionParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PostingSupplyForProductionFilter();
		this.getPickingSupplyForProductions();
		// this.getWorkOrderSupplys()
		// this.getWorkOrderProcesss()
		this.getLines();
		this.getDocumentStatuss();
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Posting Supply For Production"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPostingSupplyForProductions();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getPostingSupplyForProductions();
			}
		},
		sortDesc: {
			handler: function () {
				this.getPostingSupplyForProductions();
			}
		},
		currentPage: {
			handler: function () {
				this.getPostingSupplyForProductions();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getPostingSupplyForProductions();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PostingSupplyForProduction.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "postingsupplyforproductionindex") {
					this.getPostingSupplyForProductionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "posting_supply_for_production").first();
		},
		isShowDeleteButton: function () {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
